export default "__VITE_ASSET__82e1bcfd__"